import { render, staticRenderFns } from "./course-addPopup.vue?vue&type=template&id=74bd29f6&scoped=true"
import script from "./course-addPopup.vue?vue&type=script&lang=js"
export * from "./course-addPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd29f6",
  null
  
)

export default component.exports